import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

import { Button, Grid, Typography } from "@mui/material";

import { capitalize } from "../../utils/capitalize";
import FormikInput from "../Form/FormikInput";
import { useContent } from "../../content/useContent";

type IProps = {
  formik: any;
  setOpen: any;
  open: any;

  itemName: any;
};
const classes = {
  root: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    width: "50%",
    minWidth: "300px",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",

    boxShadow: 24,
    p: 4,
    "&:focus-visible": {
      outline: "none",
    },
  },
};
const PriceModal: React.FC<IProps> = ({
  formik,
  setOpen,
  open,

  itemName,
}) => {
  const { general, pages } = useContent();
  const { events } = pages;

  return (
    <div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={classes.root}>
            <Typography variant="h5" color="primary" component="h5">
              {`${general.addNew} ${capitalize(itemName)}`}
            </Typography>

            <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikInput
                    formik={formik}
                    name="title"
                    label={events.titleEn}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormikInput
                    formik={formik}
                    name="titleAr"
                    label={events.titleAr}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormikInput
                    formik={formik}
                    type="number"
                    name="price"
                    label={events.price}
                  />
                </Grid>
              </Grid>

              <Button
                onClick={formik.handleSubmit}
                variant="contained"
                sx={{ width: "100%", py: 1, mt: 2 }}
              >
                {`${general.addNew} ${capitalize(itemName)}`}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default PriceModal;
